import { useState } from "react";
import { NOTIFICATION_KINDS, api, type NotificationKind } from "../api";
import { Footer, PublicHeader } from "../App";
import { errorText, useT } from "../i18n";
import { queryParam } from "../router";

/**
 * Target of the link at the end of every notification mail (/unsubscribe?t=...), signed in or not
 * (PLAN.md 4.28). Like /verify, it changes nothing on opening: only the click does, so mail
 * scanners that fetch links cannot switch notifications off.
 */
export function Unsubscribe() {
  const t = useT();
  const token = queryParam("t") ?? "";
  // The token names its kind in clear (<member>.<kind>.<signature>); the server checks the signature.
  const named = token.split(".")[1];
  const kind = (NOTIFICATION_KINDS as readonly string[]).includes(named ?? "") ? (named as NotificationKind) : null;
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(kind ? null : errorText({ code: "unsubscribe_invalid" }));
  const label = kind ? t.account.notifications.kinds[kind] : "";

  async function confirm() {
    setBusy(true);
    setError(null);
    try {
      await api.unsubscribe(token);
      setDone(true);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <PublicHeader />
      <main className="narrow">
        <h2>{t.unsubscribe.title}</h2>
        {kind && !done && (
          <>
            <p>{t.unsubscribe.question(label)}</p>
            <button className="primary" onClick={() => void confirm()} disabled={busy}>
              {t.unsubscribe.confirm}
            </button>
          </>
        )}
        {done && <p role="status">{t.unsubscribe.done(label)}</p>}
        {error && <p className="error">{error}</p>}
        <p>
          <a href="/account">{t.unsubscribe.settings}</a>
        </p>
      </main>
      <Footer />
    </>
  );
}
